import styled from 'styled-components'
import { Text } from 'components/Typography'
import { FONT_WEIGHT, SPACE } from 'Theme'

export const DetailLabel = styled(Text).attrs(
  ({ bold, marginTop, marginBottom }) => ({
    mt: marginTop && SPACE.PX_15,
    mb: marginBottom && SPACE.PX_5,
    fontWeight: bold && FONT_WEIGHT.SEMI_BOLD,
  })
)`
  &:first-child {
    margin-top: 0;
  }
  text-transform: uppercase;
`
